(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunap-free-header"] && !Shopify.designMode) return;
  try {
    
  class LunapStickyHeader extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.section-header');
      if (!this.section) return;

      this.alwaysSticky = this.dataset.stickyType === 'always';
      this.currentScrollTop = 0;
      this.bounds = {};
      this.search = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);

      document.documentElement.style.setProperty('--header-height', `${this.section.offsetHeight}px`);

      if (this.alwaysSticky) {
        this.section.classList.add('shopify-section-header-sticky');
      }

      const observer = new IntersectionObserver((entries) => {
        this.bounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.section);

      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.search && this.search.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.bounds.bottom) {
        this.section.classList.add('scrolled-past-header');
        if (!this.alwaysSticky) {
          this.section.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          this.section.classList.remove('animate');
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.bounds.bottom) {
        this.section.classList.add('scrolled-past-header', 'shopify-section-header-sticky', 'animate');
        this.section.classList.remove('shopify-section-header-hidden');
      } else if (scrollTop <= this.bounds.top) {
        this.section.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('lunap-sticky-header')) {
    customElements.define('lunap-sticky-header', LunapStickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
